import { render, staticRenderFns } from "./navbar-notifications-dropdown.vue?vue&type=template&id=3c405032&scoped=true&"
import script from "./navbar-notifications-dropdown.vue?vue&type=script&lang=js&"
export * from "./navbar-notifications-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./navbar-notifications-dropdown.vue?vue&type=style&index=0&id=3c405032&lang=css&"
import style1 from "./navbar-notifications-dropdown.vue?vue&type=style&index=1&id=3c405032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c405032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c405032')) {
      api.createRecord('3c405032', component.options)
    } else {
      api.reload('3c405032', component.options)
    }
    module.hot.accept("./navbar-notifications-dropdown.vue?vue&type=template&id=3c405032&scoped=true&", function () {
      api.rerender('3c405032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navbar-notifications-dropdown.vue"
export default component.exports